// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".on-hold-button[data-v-59b7e2d1]{position:fixed;right:12vw;top:86vh;z-index:1}@media screen and (max-width:600px){.on-hold-button[data-v-59b7e2d1]{right:10vw;top:77vh}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
